import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import HoverImage from "react-hover-image/build";
import ReactStrapTable from "components/reactStrapTable";
import { cloneDeep } from "lodash";

import useAxios from "hooks/useAxios";
import Drawer from "components/Drawer";
import {
  rxManagerColumns,
  dateFormate,
  currencyFormat,
  cellRendererCheck,
  cellRenderRefillNo,
} from "utils/columns";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import HistoryIcon from "assets/icon/icon-icon-options-history.svg";
import AttachIcon from "assets/icon/icon-icon-options-attachment.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import HistoryHoverIcon from "assets/icon/icon-icon-options-history_hover.svg";
import AttachHoverIcon from "assets/icon/icon-icon-options-attachment_hover.svg";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import EyeIcon from "assets/icon/icon-icon-options-view-patient.svg";
import EyeIconHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import { ModuleAccess } from "utils/moduleaccess";
import DragDrop from "components/DragDrop";
import EditClaims from "../EditRxManager";
import Comments from "../RxManagerComment";

let tableDataBackup = [],
  rowForEdit = {},
  updatedFields = {};

let lastValidDate = new Date(new Date().setDate(new Date().getDate() - 365));
// let fallOutReasons = new IsEditabelReason(new IsEditabelReason().setIsEditableReason(new IsEditabelReason.isEditabelReson))
//let claimStatusCode = "D";
let modulename = "RxManager";
let ByPassRules = [
  "DOS Not Within Lookback Period", 
  "Vaccine Drug", 
  "C2 Drug",
  "C3 Drug",
  "C4 Drug",
  "C5 Drug",
  'Claim Not Derived - Supply Indicator "N"',
  "Drug Excluded",
  "Manual Capture",
  "Manual Non Capture",
  "Manual Capture Future Refill",
  "Manual Non Capture Future Refill",
  "",
];

let autoselectlist1 = []; 
let numberlist = ["Claim ID", "Quantity Dispensed", "Plan Paid Amount", "Patient Paid Amount", "Total Paid", "Dispensing Fee"];
let currencylist = ["Plan Paid Amount", "Dispensing Fee", "Total Paid", "Patient Paid Amount"];
let dateList = ["Service Date", "Date Rx Written", "Patient DOB", "Modified Date"];
let hideColFilterlist = ["Claim ID", "Prescription #", "Date Rx Written","Refill #", "Patient First Name", "Patient Last Name", "Patient DOB", "Prescriber NPI",
  "NDC", "Group Response ID", "BIN", "PCN", "Group", "Secondary PCN", "Secondary Group",
  "SCC", "Plan Paid Amount", "Total Paid", "Dispensing Fee","Patient Paid Amount", "Prescriber First Name", "Prescriber Last Name",
   "Quantity Dispensed", "Secondary BIN"
];
let hideSortColFilterlist = ["Claim ID", "Prescription #", "Date Rx Written","Refill #", "Patient First Name", "Patient Last Name", "Patient DOB", "Prescriber NPI",
  "NDC", "Group Response ID", "SCC", "Plan Paid Amount", "Total Paid", "Dispensing Fee","Patient Paid Amount", "Prescriber First Name", "Prescriber Last Name",
   "Quantity Dispensed"
];
let widthList = ["Drug Name","Fallout Reason", 'Covered Entity',"Pharmacy" ]

const RxManagerTable = (props) => {
  const {
    data,
    totalSize,
    onPageChange,
    AllExport,
    slelectedExportcoloumms,
    filters,
    onSearchColumnFilters = () => "",
    coveredEntity,
    refetch,
    module,
    tenantID,
    collapseSider,
    toggleSider,
    loading,
    setLoading,
    reset,
    thirdPartyAdmin
  } = props;

  const API = useAxios();
  tableDataBackup = data;
  const navigate = useNavigate();
  const [isOpenView, setOpenView] = useState(false);
  const [isPopUpOpen, setPopUpOpen] = useState(false);
  const [tableData, setTableData] = useState(tableDataBackup);
  //const [reset, setReset] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isReasonOpen, setIsReasonOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();
  const [drawer, setDrawer] = useState("");
  const [providerId, setProviderId] = useState("");
  const [editDrawer, setEditDrawer] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [detailsRowData, setDetailsRowData] = useState({});
  const [commentDrawer, setCommentDrawer] = useState(false);
  const [commentRowData, setCommentRowData] = useState({});
  const [hasStatusChanged, setSelectedStatus] = useState("");
  const [hasTouched, setTouched] = useState("");
  const [isOpenHistory, setOpenHistory] = useState(false);
  const [claimID, setClaimID] = useState("");
  const [colFilters, setColFilters] = useState({});
  const [pdfModal, setPdfModel] = useState(false);
  const [fax, setFaxDetail] = useState({});
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [isEditabelReson, setIsEditableReason] = useState(false);
  const [coloumselect, setColoumselect] = useState(false);
  const [hasDisabledSelectedCols, setHasDisabledSelectedCols] = useState(false);

  useEffect(() => {
    setHasExportPermission(ModuleAccess("RXM", "EXP"));
  }, []);

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);
  useEffect(() => {
    handlAutocoloms();
  }, []);
  const toggleHistory = (rowData) => {
    setOpenHistory(!isOpenHistory);
    setClaimID(rowData.claimID || "");
  };
  const hasPermission = (code) => {
    return ModuleAccess("RXM", code);
  };

  const renderHistoryButton = (rowData) => {
    if (hasPermission("HI"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleHistory(rowData)}
        >
          <HoverImage
            key="HistoryIcon"
            src={HistoryIcon}
            hoverSrc={HistoryHoverIcon}
            alt=""
          />
        </Button>
      );
  };
  const renderEditButton = (rowData) => {
    if(hasPermission("EDITCLAIM")){
        if (new Date(rowData.dateOfDispense) < lastValidDate) {
          return (
            <Button
              className="text-primary p-0 text-decoration-none"
              color="link"
              onClick={() => togglePopUp(rowData)}
              title="Edit Claim"
            >
              <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
            </Button>
          );
        } 
         else {
          return (
            <Button
              className="text-primary p-0 text-decoration-none"
              color="link"
              onClick={() => toggleEditDrawer(rowData)}
              title="Edit Claim"
            >
              <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
            </Button>
          );
        }
    }
   
  };

  const renderViewButton = (rowData) => {
    if (hasPermission("VWD"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleDetailsDrawer(rowData)}
        >
          <HoverImage
            key="EyeIcon"
            src={EyeIcon}
            hoverSrc={EyeIconHover}
            alt=""
          />
        </Button>
      );
  };
  const renderCommentsButton = (rowData) => {
    if (hasPermission("ADDATTACHMENT"))
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleCommentDrawer(rowData)}
          title="Attachment"
        >
          <HoverImage
            key="AttachIcon"
            src={AttachIcon}
            hoverSrc={AttachHoverIcon}
            alt=""
          />
        </Button>
      );
  };
//   {associateRefillSelected ? (
//     <div>
//         <ErrorBoundary>
//             <div className='table-card scroll-table position-relative border-0 rounded pt-0'
//                 fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
//                 <ReactStrapTable
//                     id='rx-manager-edit-table'
//                     columns={mainCol}
//                     loading={loading}
//                     data={data}
//                 />
//             </div>

//         </ErrorBoundary>
//         <Row className='mt-2'>
//             {/* <Col md={}></Col> */}
//             <Col md={12} style={{ textAlignLast: "end" }}>Total Savings:{currencyFormat(totalSavings)}</Col>
//         </Row>
//     </div>
// ) : null
// }
  const cellRenderEdit = (rowData) => {
    return (
      <div className="d-flex align-items-center justify-content-start">
        {renderEditButton(rowData)}
        {renderCommentsButton(rowData)}
        {/* {renderViewButton(rowData)} */}
      </div>
    );
  };

  const togglePdfModal = () => {
    setPdfModel(!pdfModal);
  };

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
    setDrawer("");
  };
  const toggleView = (rowData) => {
    setOpenView(!isOpenView);
    setSelectedRow(rowData);
  };

  const togglePopUp = (rowData) => {
    setPopUpOpen(!isPopUpOpen);
    setSelectedRow(rowData);
  };

  const drawerClose = (hasUpdated) => {
    setIsOpen(!isOpen);
    setDrawer("");
    if (hasUpdated) refetch();
  };

  const updateRowValue = (value, col) => {
    updatedFields[col] = value;
    if (col === "claimStatusID") {
      setSelectedStatus(parseInt(rowForEdit.claimStatusID) !== parseInt(value));
    }
  };

  const handlAutocoloms = async () => {
    autoselectlist1 = [];
    try {
      const { data } = await API.get(
        `GWConfig/coveredentity/autoselectcoloumslist/${modulename}`,
        {
          hasDefaultURL: true,
        }
      );
      if (data) {
        if (data.length > 0) {
          setHasDisabledSelectedCols(false);
        } else {
          setHasDisabledSelectedCols(true);
        }
        for (var x in data) {
          autoselectlist1.push({
            text: data[x].displayName,
            dataField: data[x].fieldName,
          });
        }
      }
    } catch (err) { }
  };

  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  };

  const cellEditRender = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
        hasTouched={hasTouched}
        requiredFields={["statusList", "text"]}
      />
    );
  };
  

  let maincol1 = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: autoselectlist1[0]?.dataField,
      text: autoselectlist1[0]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[0]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[0]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[0]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 0 ? true : false,
      inputType: dateList.includes(autoselectlist1[0]?.text) ? "date" : numberlist.includes(autoselectlist1[0]?.text) ? "number" : "text",
      width:  widthList.includes(autoselectlist1[0]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[1]?.dataField,
      text: autoselectlist1[1]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[1]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[1]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[1]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 1 ? true : false,
      inputType: dateList.includes(autoselectlist1[1]?.text) ? "date" : numberlist.includes(autoselectlist1[1]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[1]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[2]?.dataField,
      text: autoselectlist1[2]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[2]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[2]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[2]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 2 ? true : false,
      inputType: dateList.includes(autoselectlist1[2]?.text) ? "date" : numberlist.includes(autoselectlist1[2]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[2]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[3]?.dataField,
      text: autoselectlist1[3]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[3]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[3]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[3]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 3 ? true : false,
      inputType: dateList.includes(autoselectlist1[3]?.text) ? "date" : numberlist.includes(autoselectlist1[3]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[3]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[4]?.dataField,
      text: autoselectlist1[4]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[4]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[4]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[4]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 4 ? true : false,
      inputType: dateList.includes(autoselectlist1[4]?.text) ? "date" : numberlist.includes(autoselectlist1[4]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[4]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[5]?.dataField,
      text: autoselectlist1[5]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[5]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[5]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[5]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 5 ? true : false,
      inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[5]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[5]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[6]?.dataField,
      text: autoselectlist1[6]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[6]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[6]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[6]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 6 ? true : false,
      inputType: dateList.includes(autoselectlist1[6]?.text) ? "date" : numberlist.includes(autoselectlist1[6]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[6]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[7]?.dataField,
      text: autoselectlist1[7]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[7]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[7]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[7]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 7 ? true : false,
      inputType: dateList.includes(autoselectlist1[7]?.text) ? "date" : numberlist.includes(autoselectlist1[7]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[7]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[8]?.dataField,
      text: autoselectlist1[8]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[8]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[8]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[8]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 8 ? true : false,
      inputType: dateList.includes(autoselectlist1[8]?.text) ? "date" : numberlist.includes(autoselectlist1[8]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[8]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[9]?.dataField,
      text: autoselectlist1[9]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[9]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[9]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[9]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 9 ? true : false,
      inputType: dateList.includes(autoselectlist1[9]?.text) ? "date" : numberlist.includes(autoselectlist1[9]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[9]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[10]?.dataField,
      text: autoselectlist1[10]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[10]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[10]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[10]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 10 ? true : false,
      inputType: dateList.includes(autoselectlist1[10]?.text) ? "date" : numberlist.includes(autoselectlist1[10]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[10]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[11]?.dataField,
      text: autoselectlist1[11]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[11]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[11]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[11]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 11 ? true : false,
      inputType: dateList.includes(autoselectlist1[11]?.text) ? "date" : numberlist.includes(autoselectlist1[11]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[11]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[12]?.dataField,
      text: autoselectlist1[12]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[12]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[12]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[12]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 12 ? true : false,
      inputType: dateList.includes(autoselectlist1[12]?.text) ? "date" : numberlist.includes(autoselectlist1[12]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[12]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[13]?.dataField,
      text: autoselectlist1[13]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[13]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[13]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[13]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 13 ? true : false,
      inputType: dateList.includes(autoselectlist1[13]?.text) ? "date" : numberlist.includes(autoselectlist1[13]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[13]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[14]?.dataField,
      text: autoselectlist1[14]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[14]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[14]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[14]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 14 ? true : false,
      inputType: dateList.includes(autoselectlist1[14]?.text) ? "date" : numberlist.includes(autoselectlist1[14]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[14]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[15]?.dataField,
      text: autoselectlist1[15]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[15]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[15]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[15]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 15 ? true : false,
      inputType: dateList.includes(autoselectlist1[15]?.text) ? "date" : numberlist.includes(autoselectlist1[15]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[15]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[16]?.dataField,
      text: autoselectlist1[16]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[16]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[16]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[16]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 16 ? true : false,
      inputType: dateList.includes(autoselectlist1[16]?.text) ? "date" : numberlist.includes(autoselectlist1[16]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[16]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[17]?.dataField,
      text: autoselectlist1[17]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[17]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[17]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[17]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 17 ? true : false,
      inputType: dateList.includes(autoselectlist1[17]?.text) ? "date" : numberlist.includes(autoselectlist1[17]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[17]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[18]?.dataField,
      text: autoselectlist1[18]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[18]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[18]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[18]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 18 ? true : false,
      inputType: dateList.includes(autoselectlist1[18]?.text) ? "date" : numberlist.includes(autoselectlist1[18]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[18]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[19]?.dataField,
      text: autoselectlist1[19]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[19]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[19]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[19]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 19 ? true : false,
      inputType: dateList.includes(autoselectlist1[19]?.text) ? "date" : numberlist.includes(autoselectlist1[19]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[19]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[20]?.dataField,
      text: autoselectlist1[20]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[20]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[20]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[20]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 20 ? true : false,
      inputType: dateList.includes(autoselectlist1[20]?.text) ? "date" : numberlist.includes(autoselectlist1[20]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[20]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[21]?.dataField,
      text: autoselectlist1[21]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[21]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[21]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[21]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 21 ? true : false,
      inputType: dateList.includes(autoselectlist1[21]?.text) ? "date" : numberlist.includes(autoselectlist1[21]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[21]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[22]?.dataField,
      text: autoselectlist1[22]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[22]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[22]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[22]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 22 ? true : false,
      inputType: dateList.includes(autoselectlist1[22]?.text) ? "date" : numberlist.includes(autoselectlist1[22]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[22]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[23]?.dataField,
      text: autoselectlist1[23]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[23]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[23]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[23]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 23 ? true : false,
      inputType: dateList.includes(autoselectlist1[23]?.text) ? "date" : numberlist.includes(autoselectlist1[23]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[23]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[24]?.dataField,
      text: autoselectlist1[24]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[24]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[24]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[24]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 24 ? true : false,
      inputType: dateList.includes(autoselectlist1[24]?.text) ? "date" : numberlist.includes(autoselectlist1[24]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[24]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[25]?.dataField,
      text: autoselectlist1[25]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[25]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[25]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[25]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 25 ? true : false,
      inputType: dateList.includes(autoselectlist1[25]?.text) ? "date" : numberlist.includes(autoselectlist1[25]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[25]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[26]?.dataField,
      text: autoselectlist1[26]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[26]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[26]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[26]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 26 ? true : false,
      inputType: dateList.includes(autoselectlist1[26]?.text) ? "date" : numberlist.includes(autoselectlist1[26]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[26]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[27]?.dataField,
      text: autoselectlist1[27]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[27]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[27]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[27]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 27 ? true : false,
      inputType: dateList.includes(autoselectlist1[27]?.text) ? "date" : numberlist.includes(autoselectlist1[27]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[27]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[27]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[27]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[28]?.dataField,
      text: autoselectlist1[28]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[28]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[28]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[28]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 28 ? true : false,
      inputType: dateList.includes(autoselectlist1[28]?.text) ? "date" : numberlist.includes(autoselectlist1[28]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[28]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[28]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[28]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[29]?.dataField,
      text: autoselectlist1[29]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[29]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[29]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[29]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 29 ? true : false,
      inputType: dateList.includes(autoselectlist1[29]?.text) ? "date" : numberlist.includes(autoselectlist1[29]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[29]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[29]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[29]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[30]?.dataField,
      text: autoselectlist1[30]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[30]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[30]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[30]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 30 ? true : false,
      inputType: dateList.includes(autoselectlist1[30]?.text) ? "date" : numberlist.includes(autoselectlist1[30]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[30]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[30]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[30]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[31]?.dataField,
      text: autoselectlist1[31]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[31]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[31]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[31]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 31 ? true : false,
      inputType: dateList.includes(autoselectlist1[31]?.text) ? "date" : numberlist.includes(autoselectlist1[31]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[31]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[31]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[31]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[32]?.dataField,
      text: autoselectlist1[32]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[32]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[32]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[32]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 32 ? true : false,
      inputType: dateList.includes(autoselectlist1[32]?.text) ? "date" : numberlist.includes(autoselectlist1[32]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[32]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[32]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[32]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[33]?.dataField,
      text: autoselectlist1[33]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[33]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[33]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[33]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 33 ? true : false,
      inputType: dateList.includes(autoselectlist1[33]?.text) ? "date" : numberlist.includes(autoselectlist1[33]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[33]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[33]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[33]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[34]?.dataField,
      text: autoselectlist1[34]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[34]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[34]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[34]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 34 ? true : false,
      inputType: dateList.includes(autoselectlist1[34]?.text) ? "date" : numberlist.includes(autoselectlist1[34]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[34]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[34]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[34]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[35]?.dataField,
      text: autoselectlist1[35]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[35]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[35]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[35]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 35 ? true : false,
      inputType: dateList.includes(autoselectlist1[35]?.text) ? "date" : numberlist.includes(autoselectlist1[35]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[35]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[35]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[35]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[36]?.dataField,
      text: autoselectlist1[36]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[36]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[36]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[36]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 36 ? true : false,
      inputType: dateList.includes(autoselectlist1[36]?.text) ? "date" : numberlist.includes(autoselectlist1[36]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[36]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[36]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[36]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[37]?.dataField,
      text: autoselectlist1[37]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[37]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[37]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[37]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 37 ? true : false,
      inputType: dateList.includes(autoselectlist1[37]?.text) ? "date" : numberlist.includes(autoselectlist1[37]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[37]?.text) ? 288 : 144,   
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[37]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterlist.includes(autoselectlist1[37]?.text) ? true : false,
    },
  ];

  let mainCol = [
    {
      dataField: "edit",
      text: "Options",
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "gwClaimID",
      text: "Claim ID",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      cellRenderer: (row) => cellRendererCheck(row.gwClaimID),
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.comments),
    },
    {
      dataField: "dateOfDispense",
      text: "Service Date",
      sort: false,
      width: 144,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.dateOfDispense),
    },
    {
      dataField: "dateRXWritten",
      text: "Date Rx Written",
      sort: true,
      width: 144,
      show: true,
      inputType: "date",
      cellRenderer: (row) => dateFormate(row.dateRXWritten),
    },
    {
      dataField: "prescriptionNumber",
      text: "Prescription #",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.prescriptionNumber),
    },
    {
      dataField: "fillNumber",
      text: "Refill #",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRenderRefillNo(row.fillNumber),
    },
    {
      dataField: "memberFirstName",
      text: "Patient First Name",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.memberFirstName),
    },
    {
      dataField: "memberLastName",
      text: "Patient Last Name",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.memberLastName),
    },
    {
      dataField: "memberDOB",
      text: "Patient DOB",
      sort: true,
      width: 144,
      show: true,
      inputType: "date",
      cellRenderer: (row) => dateFormate(row.memberDOB),
    },
    {
      dataField: "prescriberFirstName",
      text: "Prescriber First Name",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.prescriberFirstName),
    },
    {
      dataField: "prescriberLastName",
      text: "Prescriber Last Name",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.prescriberLastName),
    },
    {
      dataField: "prescriberNPI",
      text: "Prescriber NPI",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.prescriberNPI),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "quantity",
      text: "Quantity Dispensed",
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      cellRenderer: (row) => cellRendererCheck(row.quantity),
    },
    {
      dataField: "drugDescription",
      text: "Drug Name",
      sort: false,
      width: 288,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },
    {
      dataField: "drugManufacturerName",
      text: "Mfg. Name",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.drugManufacturerName),
    },
    {
      dataField: "brandGenericFlag",
      text: "Drug Indicator",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter:true,
      cellRenderer: (row) => cellRendererCheck(row.brandGenericFlag),
    },
    {
      dataField: "claimType",
      text: "Claim Type",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter:true,
      cellRenderer: (row) => cellRendererCheck(row.claimType),
    },
    {
      dataField: "claimSubType",
      text: "Claim Sub Type",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter:true,
      cellRenderer: (row) => cellRendererCheck(row.claimSubType),
    },
    {
      dataField: "claimMappingStatus",
      text: "Replenished Status",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter:true,
      cellRenderer: (row) => cellRendererCheck(row.claimMappingStatus),
    },
    {
      dataField: "reason",
      text: "Fallout Reason",
      sort: false,
      width: 288,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.reason),
    },
    {
      dataField: "coveredEntity",
      text: 'Covered Entity',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.coveredEntity),
    },
    {
      dataField: "pharmacyName",
      text: "Pharmacy",
      sort: false,
      width: 288,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.pharmacyName),
    },
    {
      dataField: "storeNPI",
      text: 'Pharmacy NABP or NPI',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.storeNPI),
    },
    {
      dataField: "groupResponseID",
      text: "Group Response ID",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.groupResponseID),
    },
    {
      dataField: "primaryBIN",
      text: "BIN",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.primaryBIN),
    },
    {
      dataField: "primaryPCN",
      text: "PCN",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.primaryPCN),
    },
    {
      dataField: "primaryGroupNumber",
      text: "Group",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.primaryGroupNumber),
    },
    {
      dataField: "secondaryBIN",
      text: "Secondary BIN",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.secondaryBIN),
    },
    {
      dataField: "secondaryPCN",
      text: "Secondary PCN",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.secondaryPCN),
    },
    {
      dataField: "secondaryGroup",
      text: "Secondary Group",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.secondaryGroup),
    },
    {
      dataField: "submissionClarificationCode",
      text: "SCC",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row) => cellRendererCheck(row.submissionClarificationCode),
    },
    {
      dataField: "planPaidAmount",
      text: "Plan Paid Amount",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      cellRenderer: (row) => currencyFormat(row.planPaidAmount),
    },
    {
      dataField: "patientPaidAmount",
      text: "Patient Paid Amount",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      cellRenderer: (row) => currencyFormat(row.patientPaidAmount),
    },
    {
      dataField: "netCollection",
      text: "Total Paid",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      cellRenderer: (row) => currencyFormat(row.netCollection),
    },
    {
      dataField: "_340BDispensingFee",
      text: "Dispensing Fee",
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      cellRenderer: (row) => currencyFormat(row._340BDispensingFee),
    },
    {
      dataField: "modifiedBy",
      text: "Modified By",
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.modifiedBy),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: false,
      width: 144,
      show: true,
      inputType: "date",
      hideColFilter: true,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },
  ];

  const handleReason = (row) => {
    setIsReasonOpen(!isReasonOpen);
    setSelectedRow(row);
  };

  const cellRendererReason = (row) => {
    const { reason } = row;
    if (reason) {
      return (
        <span
          className="cursor-pointer text-decoration-underline"
          onClick={() => handleReason(row)}
        >
          {reason}
        </span>
      );
    }
    return "-";
  };

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
      setColFilters(colFilter);
    }
  };

  const handleFilterCancel = () => {
    refetch();
  };

  const toggleEditDrawer = (rowData) => {
    setEditDrawer((pre) => !pre);
    setEditRowData(rowData);
  };

  const toggleCommentDrawer = (rowData) => {
    setCommentDrawer((pre) => !pre);
    setCommentRowData(rowData);
    if(commentDrawer){
        refetch();
    }
  };
  const toggleDetailsDrawer = (rowData) => {
    setDetailsDrawer((pre) => !pre);
    setDetailsRowData(rowData);
  };

  const cellRenderLink = (rowData) => {
    return (
      <span>
        {rowData.poid}
      </span>
    );
  };
  

  return (
    <div>
      <h5 className="f-16 text-primary font-weight-700">
        Claims Count ({totalSize})
      </h5>
      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={
          data.length > 0
            ? `${collapseSider ? "collapse-fixed-height" : "fixed-height"}`
            : "default"
        }
      >
        <ReactStrapTable
          id="inventory-table"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          hasPagination
          data={tableData}
          columns={autoselectlist1.length > 0 ? maincol1 : mainCol}
          AllExport={AllExport}
          slelectedExport={slelectedExportcoloumms}
          filters={filters}
          totalRecords={totalSize}
          pageSize={filters.pageSize}
          currentPage={filters.currentPage}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          hasColselect={true}
          onSelectColoums={handleselectColoums}
          hasExportPermission1={true}
          autoselectlist1={autoselectlist1}
          disableSelectedColumn={hasDisabledSelectedCols}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          enabletogglesider={true}
          hasExportPermission={hasExportPermission}
        />
        {/* <FallourReasonsModal
          isOpen={isReasonOpen}
          toggle={handleReason}
          row={selectedRow}
        /> */}
         <Modal
          isOpen={isPopUpOpen}
          toggle={togglePopUp}
          size="xl"
          className="xl"
        >
          <ModalHeader toggle={togglePopUp}>Edit Claims</ModalHeader>
          <ModalBody>
            <p>
            “Oh no! This claim is beyond 365 days (i.e. 12 months)". To change
            the status, you will need to submit a support ticket to
            support@thepharmaforce.com.
              {/* <span>
                <a href="mailto:support@thepharmaforce.com">
                  support@thepharmaforce.com.
                </a>
              </span> */}
            </p>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={coloumselect}
          toggle={handleselectColoums}
          size="lg"
          className="lg"
        >
          <ModalHeader toggle={handleselectColoums}>
            Column Selector
          </ModalHeader>
          <ModalBody>
            <DragDrop
              cancalcolselect={handleselectColoums}
              refetch={handleFilterCancel}
              reloadautocolum={handlAutocoloms}
              modulename={modulename}
            />
          </ModalBody>
        </Modal>
        <Drawer
          direction="end"
          title="Edit Claims"
          isOpen={editDrawer}
          toggle={toggleEditDrawer}
          size="lg"
        >
          <EditClaims
            hiddenCard={true}
            tenantID={tenantID}
            claimData={editRowData}
            onClose={toggleEditDrawer}
            setEditDrawer={setEditDrawer}
            refetch={handleFilterCancel}
          />
        </Drawer>
        <Drawer
          direction="end"
          title="Add Attachments"
          isOpen={commentDrawer}
          toggle={toggleCommentDrawer}
          size="lg"
        >
          <Comments
            hiddenCard={true}
            tenantID={tenantID}
            claimData={commentRowData}
            onClose={toggleCommentDrawer}
          />
        </Drawer>
        <Drawer
          direction="end"
          title="Show Claim Details"
          isOpen={detailsDrawer}
          toggle={toggleDetailsDrawer}
          size="lg"
        >
          {/* <ShowClaims
            hiddenCard={true}
            tenantID={tenantID}
            rowData={detailsRowData}
            onClose={toggleDetailsDrawer}
          /> */}
        </Drawer>
        <Modal isOpen={isOpenView} toggle={toggleView} size="sm" className="sm">
          <ModalHeader toggle={toggleView}>Edit Claims</ModalHeader>
          <ModalBody>
            “Oh no! This claim is beyond 180 days (i.e. 6 months)". To change
            the status, you will need to submit a support ticket to
            support@thepharmaforce.com.
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};
export default RxManagerTable;
